import * as React from 'react'
import * as style from './style.scss'

const Body: React.FunctionComponent = ({ children }) => <div className={style.body}>{children}</div>

export default Body
